export enum ExchangeRoute {
  HOME = '/',
  MAP = '/map',
  PORTFOLIO = '/portfolio',
  PORTFOLIO_ACCOUNT = '/portfolio/:account',
  HOW_IT_WORKS = '/how-it-works',
  HOW_IT_WORKS_NOTION = 'https://bit.ly/sharelandwiki',
}
